import { render } from "./Nueva.vue?vue&type=template&id=bc9c535c"
import script from "./Nueva.vue?vue&type=script&lang=js"
export * from "./Nueva.vue?vue&type=script&lang=js"

import "./Nueva.vue?vue&type=style&index=0&id=bc9c535c&lang=css"

import exportComponent from "/var/www/html/helados_admin_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__